/**
 * .check-wrap / .form-popup / .popup-bg
 */
export class HomeFormPopup {
    static init(): void {
        const $ = (window as unknown as { $?: (s: string) => JQueryForm }).$;
        if (!$) return;

        $(".check-wrap button").on("click", () => {
            $(".form-popup").css({ display: "block" });
            $(".popup-bg").addClass("active");
        });
        $(".p-close").on("click", () => {
            $(".form-popup").css({ display: "none" });
            $(".popup-bg").removeClass("active");
            $("html, body").removeClass("lock");
        });
    }
}

interface JQueryForm {
    on(ev: string, fn: () => void): JQueryForm;
    css(o: object): JQueryForm;
    addClass(c: string): JQueryForm;
    removeClass(c: string): JQueryForm;
}
